<template>
  <div class="section">
    <div>
      <p
        style="
          text-indent: 40px;
          font-size: 14pt;
          padding-top: 60px;
          padding-left: 5px;
        "
      >
        {{ this.name }}在{{ this.num }}大维度的总体状态特征分析如下：
      </p>

      <img
        :src="images.logo"
        style="
          height: auto;
          width: 15%;
          float: right;
          margin-right: 50px;
          margin-top: -45px;
        "
      />
    </div>
    <div style="margin-top: 15px">
      <characteristics :model="this.model.result" :result="this.result" />
    </div>
    <div style="padding: 40px 50px 0px 50px">
      <p
        style="
          text-indent: 40px;
          line-height: 20px;
          margin-top: -40px;
          font-size: 14px;
        "
      >
        {{ content5 }}
      </p>
    </div>
    <!-- <div style="text-align: center;margin-top:50px">
      <img :src="images.page" style="height:auto%;width:5%;" />
    </div> -->
  </div>
</template>

<script>
import { pageFour } from "@/views/report/config/three";
import { pageThree } from "@/views/report/config/three";
import characteristics from "@/components/dataView/table/three/characteristics.vue";
export default {
  props: ["model", "result", "name"],
  components: { characteristics },
  data() {
    return {
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
        page: require("../../../assets/images/page5/page.png"),
      },
      num: "",
      SectionviewData: pageFour.SectionviewData,
      content4: pageThree.content4,
      content5: pageThree.content5,
    };
  },
  watch: {
    result(val) {
      this.result = val;
      this.panduan();
    },
  },
  methods: {
    panduan() {
      if (this.result.length == 1) {
        this.num = "一";
      } else if (this.result.length == 2) {
        this.num = "二";
      } else if (this.result.length == 3) {
        this.num = "三";
      } else if (this.result.length == 4) {
        this.num = "四";
      } else if (this.result.length == 5) {
        this.num = "五";
      } else if (this.result.length == 6) {
        this.num = "六";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;

  height: 1124px; //A4纸的高度像素
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/pageFive.vue